import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { ErrorMessages } from '@types';
import { parseZodErrors, textAreaInputSchema } from '@utils';
import { ZodError } from 'zod';
import { TextAreaTemplate } from '@templates';

export const PropertyUsage = () => {
  const { data, update } = usePlanningBreachStore();
  const navigate = useNavigate();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const MAX_LENGTH = 500;
  const labelText = 'How often is the property used as a short-term let?';
  const description = 'For example, every weekend or several times a month.';

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    update('issueInfo', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonNext = {
    onClick: () => {
      try {
        textAreaInputSchema({
          fieldName: 'issueInfo',
          requiredMessage: 'Enter details about the issue.',
          maxLength: MAX_LENGTH,
          maxLengthMessage: 'Details must be 500 characters or less.',
        }).parse({
          issueInfo: data.issueInfo,
        });
        navigate(RoutesList.SHORT_TERM_LETS_RESPONSIBILITY);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => navigate(RoutesList.SHORT_TERM_LETS_DATE),
  };

  return (
    <TextAreaTemplate
      labelText={labelText}
      description={description}
      initialTextValue={data.issueInfo}
      errorPath={'issueInfo'}
      errorMessages={errorMessages}
      maxLength={MAX_LENGTH}
      onChange={handleChange}
      buttonNext={buttonNext}
      buttonPrevious={buttonPrevious}
    />
  );
};
